<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Success"
      />
      <h1>
        Success
      </h1>
      <p>
        Payment succeeded, thank you for using RutSolve!
      </p>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
</script>
